<template>
    <v-app-bar v-bind:class="{ impersonating: isImpersonating}">
        <v-toolbar-title v-if="isLoggedIn">Profesional: <strong>{{ username }}</strong></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn to="/login" v-if="!isLoggedIn">Login</v-btn>
        <v-btn to="/home">Inicio</v-btn>
        <v-btn to="/agenda" v-if="isLoggedIn">Agenda</v-btn>
        <v-btn to="/config" v-if="isLoggedIn && !isReadonly">Configurar</v-btn>
        <v-btn to="/patient-list" v-if="isLoggedIn && !isReadonly">Pacientes</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="isLoggedIn" @click="logUserOut">
            <v-icon color="red">mdi-logout</v-icon>
        </v-btn>
    </v-app-bar>
</template>

<script>
export default {
    data() {
        return {
            user: {}
        };
    },
    methods: {
        logUserOut() {
            this.$store.dispatch('logout');
            this.$router.push("/login");
        }
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.isAuthenticated;
        },
        isReadonly() {
            return this.$store.getters.readonly;
        },
        username() {
            //console.log('getUserDetails from NavBarTherapist');
            return this.$store.getters.userName;
        },
        isImpersonating() {
            return (this.$store.getters.dbId !== this.$store.getters.therapistId)
        }
    },
};
</script>
<style>
.impersonating {
    background-color: lightcoral !important;
}
</style>
